import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import React__default, { useState, useRef, useEffect } from 'react';
import MenuSearchBox from '../22740ec41a145d8af6012eba975137f522245a8cabd780eba272ede238cbfe20.cfe-internal.js';
import useLatest from '../../../../hooks/useLatest/70d83229838d1f1f54143abcad3f88dcc130955a0eeb4036f7b0531864f0de79.cfe-internal.js';
import mergeRefs from '../../../../utils/mergeRefs/9ec064816ea12fff6e1a85a3a984bee573572d869469708abbe6afd1d77852e7.cfe-internal.js';
import wrapEvent from '../../../../utils/wrapEvent/23c80f7add1e49cb7ec4f51c7147fefad38efa28a6c83d021f7f4e40fcc22e85.cfe-internal.js';
import { SUBMENU_POPPER_OFFSET, FLYOUT_POPPER_OFFSET } from '../../../../utils/45f71cf1e17e207ef406aad1e7e1d5a2ce1f4ae4382fd00a84689b09e31968d3.cfe-internal.js';

var _excluded = ["role", "tabIndex", "highlightedIndex", "onHighlightedIndexChange", "children", "searchBoxRef", "anchorRef", "isSubmenu", "onKeyDown", "isNavItem", "maxHeight", "minWidth", "searchable", "menuItemContainerClass", "searchTerm", "setSearchTerm", "data-popper-ready", "style"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context2, _context3; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(source), !0)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function useChildrenRefs(children, getAdditionalProps, isNavItem, searchable) {
  var _context;

  var refs = useRef({}); // eslint-disable-next-line no-return-assign

  var createRefCallback = function createRefCallback(index) {
    return function (node) {
      return refs.current[index] = node;
    };
  };

  var refIndex = searchable ? 1 : 0;

  var allChildren = _mapInstanceProperty(_context = React__default.Children).call(_context, children, function (child) {
    if (isNavItem(child)) {
      var myIndex = refIndex;
      refIndex += 1;
      var additionalProps = getAdditionalProps(child, myIndex);
      return /*#__PURE__*/React__default.cloneElement(child, _objectSpread({
        ref: mergeRefs(createRefCallback(myIndex), child.ref)
      }, additionalProps));
    }

    return child;
  });

  refs.current.length = refIndex;
  return [refs, allChildren];
}

var ArrowNav = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var role = _ref.role,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? -1 : _ref$tabIndex,
      highlightedIndex = _ref.highlightedIndex,
      onHighlightedIndexChange = _ref.onHighlightedIndexChange,
      children = _ref.children,
      searchBoxRef = _ref.searchBoxRef,
      anchorRef = _ref.anchorRef,
      isSubmenu = _ref.isSubmenu,
      onKeyDown = _ref.onKeyDown,
      _ref$isNavItem = _ref.isNavItem,
      isNavItem = _ref$isNavItem === void 0 ? function () {
    return true;
  } : _ref$isNavItem,
      maxHeight = _ref.maxHeight,
      minWidth = _ref.minWidth,
      searchable = _ref.searchable,
      menuItemContainerClass = _ref.menuItemContainerClass,
      searchTerm = _ref.searchTerm,
      setSearchTerm = _ref.setSearchTerm,
      isPopperReady = _ref['data-popper-ready'],
      style = _ref.style,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isKeyboardUser = _useState2[0],
      setIsKeyboardUser = _useState2[1];

  var containerRef = useRef(null);
  var menuItemContainerRef = useRef(null);

  var _useChildrenRefs = useChildrenRefs(children, function (child, index) {
    return {
      tabIndex: -1,
      onMouseEnter: wrapEvent(child.props.onMouseEnter, function () {
        setIsKeyboardUser(false);
        onHighlightedIndexChange(index);
      })
    };
  }, isNavItem, searchable),
      _useChildrenRefs2 = _slicedToArray(_useChildrenRefs, 2),
      refs = _useChildrenRefs2[0],
      allChildren = _useChildrenRefs2[1];

  var isKeyboardUserRef = useLatest(isKeyboardUser); // Update the focused menu item when the highlighted index changes

  useEffect(function () {
    if (isPopperReady) {
      if (refs.current[highlightedIndex]) {
        // Scroll the item into view when navigating with a keyboard
        var element = refs.current[highlightedIndex];

        if (isKeyboardUserRef.current && menuItemContainerRef.current) {
          var scrollBottom = menuItemContainerRef.current.clientHeight + menuItemContainerRef.current.scrollTop;
          var elementBottom = element.offsetTop + element.offsetHeight;

          if (elementBottom > scrollBottom) {
            menuItemContainerRef.current.scrollTop = elementBottom - menuItemContainerRef.current.clientHeight;
          } else if (element.offsetTop < menuItemContainerRef.current.scrollTop) {
            menuItemContainerRef.current.scrollTop = element.offsetTop;
          }
        }
        /* preventScroll isn't strictly needed, and doesn't do anything in Safari/IE11.
         * For keyboard users it makes no difference since the item is already in view when .focus() is called.
         * For mouse users, it prevents scrolling from occurring when hovering over a menu item that is partially out of view.
         */


        element.focus({
          preventScroll: true
        });
      } else if (highlightedIndex === 0 && searchable) {
        searchBoxRef === null || searchBoxRef === void 0 ? void 0 : searchBoxRef.current.focus();
      } else {
        var _anchorRef$current;

        anchorRef === null || anchorRef === void 0 ? void 0 : (_anchorRef$current = anchorRef.current) === null || _anchorRef$current === void 0 ? void 0 : _anchorRef$current.focus();
      }
    }
  }, [highlightedIndex, refs, searchable, allChildren.length, // Needed to prevent QuickSearch from losing focus in some cases when items are loaded asynchronously while the user is navigating
  isPopperReady, isKeyboardUserRef, searchBoxRef, anchorRef]);
  var numChildren = refs.current.length;

  var handleKeyDown = function handleKeyDown(e) {
    setIsKeyboardUser(true);

    if (e.key === 'ArrowDown') {
      e.preventDefault(); // prevent scroll

      if (highlightedIndex !== -1) {
        onHighlightedIndexChange((highlightedIndex + 1) % numChildren);
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault(); // prevent scroll

      if (highlightedIndex !== -1) {
        onHighlightedIndexChange((highlightedIndex - 1 + numChildren) % numChildren);
      }
    } else if (e.key === 'PageUp' || e.key === 'Home') {
      var _containerRef$current;

      // Only call the highlighted index change handler for the current nav list (i.e. if the event bubbles up to a parent nav list, don't call the highlighted index change handler on the parent nav list)
      if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target)) {
        onHighlightedIndexChange(0);
      }
    } else if (e.key === 'PageDown' || e.key === 'End') {
      var _containerRef$current2;

      // Only call the highlighted index change handler for the current nav list (i.e. if the event bubbles up to a parent nav list, don't call the highlighted index change handler on the parent nav list)
      if ((_containerRef$current2 = containerRef.current) !== null && _containerRef$current2 !== void 0 && _containerRef$current2.contains(e.target)) {
        var lastIndex = numChildren - 1;
        onHighlightedIndexChange(lastIndex);
      }
    }
  };

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React__default.createElement("div", _extends({
      ref: mergeRefs(containerRef, ref),
      role: role,
      tabIndex: tabIndex,
      onKeyDown: wrapEvent(onKeyDown, handleKeyDown),
      "data-popper-ready": isPopperReady,
      style: _objectSpread(_objectSpread({}, style), {}, {
        minWidth: minWidth
      })
    }, rest), searchable && /*#__PURE__*/React__default.createElement(MenuSearchBox, {
      value: searchTerm,
      ref: searchBoxRef,
      onChange: function onChange(e) {
        setSearchTerm === null || setSearchTerm === void 0 ? void 0 : setSearchTerm(e.target.value);
      },
      onFocus: function onFocus() {
        return onHighlightedIndexChange(0);
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      role: "presentation",
      style: {
        maxHeight: maxHeight !== null && maxHeight !== void 0 ? maxHeight : // This logic is located here instead of BaseMenu.js so the maxHeight will update with screen resizing (Popper has a resize listener that causes this to rerender)
        Math.min(350, (isSubmenu ? // Submenus: window height - submenu popper offset - 8px of container padding - half of anchor height (fallback to default 18px))
        document.documentElement.clientHeight - SUBMENU_POPPER_OFFSET[0] : // Menus: half of window height - menu popper offset - 8px of container padding - half of anchor height (fallback to default 18px)
        document.documentElement.clientHeight / 2 - FLYOUT_POPPER_OFFSET[1]) - 8 - (anchorRef !== null && anchorRef !== void 0 && anchorRef.current ? anchorRef.current.offsetHeight / 2 : 18))
      },
      className: menuItemContainerClass,
      ref: menuItemContainerRef
    }, allChildren))
  );
});
var ArrowNav$1 = ArrowNav;

export { ArrowNav$1 as default };
